import React from 'react';
import { motion } from 'framer-motion';
import { Search, Calculator, Ship, Scale, Truck, Wrench } from 'lucide-react';
const services = [{
  title: 'Inspección de Vehículos',
  description: 'Análisis detallado de daños, condición mecánica y potencial de mercado antes de comprar.',
  icon: Search
}, {
  title: 'Cálculo de Gastos',
  description: 'Estimación precisa de precio de subasta, impuestos (DAI, IVA, etc.), costos de primera matrícula, costo estimado de partes y costo estimado de reparación.',
  icon: Calculator
}, {
  title: 'Logística de Envío',
  description: 'Gestión de transporte terrestre en USA y flete marítimo seguro.',
  icon: Ship
}, {
  title: 'Consigue tus Piezas',
  description: '¿Problemas para encontrar piezas? Nosotros te ayudamos a localizarlas y adquirirlas de forma rápida y segura.',
  icon: Wrench
}, {
  title: 'Asesoría Legal',
  description: 'Verificación de títulos (Clean, Salvage, Rebuildable) y trámites de circulación (emisión de gases, experticia, placas).',
  icon: Scale
}, {
  title: 'Transporte de grúa a donde necesites.',
  description: 'Gestionamos la entrega de tu vehículo desde la almacenadora hasta donde tu lo necesites.',
  icon: Truck
}];
export function ServicesSection() {
  return <section id="services" className="py-20 bg-earia-bg" data-id="element-378">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379">
        <div className="text-center mb-16" data-id="element-380">
          <h2 className="text-3xl md:text-4xl font-bold text-earia-text-heading mb-4" data-id="element-381">
            Nuestros servicios
          </h2>
          <p className="text-earia-text-body max-w-2xl mx-auto text-lg" data-id="element-382">
            Cubrimos cada etapa del proceso de importación para garantizar tu
            inversión.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-383">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-earia-card border border-earia-border rounded-xl p-6 hover:shadow-lg hover:border-earia-accent/30 transition-all group" data-id="element-384">
              <div className="flex items-center gap-4 mb-4" data-id="element-385">
                <div className="p-3 bg-earia-bg-alt rounded-lg border border-earia-border group-hover:border-earia-accent/50 transition-colors" data-id="element-386">
                  <service.icon className="w-6 h-6 text-earia-accent-hover" data-id="element-387" />
                </div>
                <div className="h-2 w-2 rounded-full bg-earia-accent" data-id="element-388"></div>
              </div>

              <h3 className="text-xl font-bold text-earia-text-heading mb-2" data-id="element-389">
                {service.title}
              </h3>
              <p className="text-earia-text-body text-sm leading-relaxed" data-id="element-390">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}